/* Maizon Elle redesign 2026: behaviour for the me-* sections. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function $$(sel, el) { return [].slice.call((el || document).querySelectorAll(sel)); }
  // Formats ISK like the store's money format: amount_no_decimals gives 1,234, the comma_separator variant gives 1.234
  function fmt(n, f) {
    f = f || '{{amount_no_decimals}} kr';
    var sep = f.indexOf('comma_separator') > -1 ? '.' : f.indexOf('space_separator') > -1 ? ' ' : ',';
    return f.replace(/\{\{\s*\w+\s*\}\}/, String(Math.round(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, sep));
  }

  // Add items to the cart, then let Stiletto refresh its count and open the cart drawer.
  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Ekki tókst að setja í körfu.');
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
        var icon = document.querySelector('[data-js-cart-icon]');
        if (icon) icon.click();
        return data;
      });
    });
  }

  // Homepage product tabs
  $$('[data-me-tabs]').forEach(function (sec) {
    var tabs = $$('.me-tab', sec);
    function select(t) {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); x.tabIndex = x === t ? 0 : -1; });
      $$('.me-panel', sec).forEach(function (p) { p.hidden = p.dataset.panel !== t.dataset.tab; });
    }
    tabs.forEach(function (t, i) {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        select(next); next.focus();
      });
    });
  });

  // Build-a-suit
  $$('[data-me-set]').forEach(function (sec) {
    var btn = sec.querySelector('[data-set-add]');
    var msg = sec.querySelector('[data-set-msg]');
    var label = btn.textContent;
    var colour = (sec.querySelector('.me-seg button') || {}).dataset;
    colour = colour ? colour.color : null;
    function rows() { return $$('.me-piece', sec).filter(function (r) { return r.dataset.color === colour; }); }
    function say(t, kind) { msg.textContent = t || ''; msg.dataset.kind = kind || ''; }
    function total() {
      var sum = 0;
      rows().forEach(function (r) { var c = r.querySelector('input'); if (c.checked) sum += +c.dataset.price; });
      sec.querySelector('[data-set-total]').innerHTML = fmt(sum, sec.dataset.moneyFormat).replace(/\s(kr\.?)$/, ' <small>$1</small>');
      btn.setAttribute('aria-disabled', sum > 0 ? 'false' : 'true');
      if (!sum) say('Veldu að minnsta kosti eina flík.', 'none'); else if (msg.dataset.kind === 'none') say('');
    }
    $$('.me-piece input', sec).forEach(function (i) { i.addEventListener('change', total); });
    $$('.me-piece select', sec).forEach(function (s) {
      s.addEventListener('change', function () { s.classList.remove('is-missing'); if (msg.dataset.kind === 'size') say(''); });
    });
    $$('.me-seg button', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var prev = rows();
        colour = b.dataset.color;
        $$('.me-seg button', sec).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('.me-set__img img', sec).forEach(function (im) { im.classList.toggle('is-active', im.dataset.color === colour); });
        sec.querySelector('[data-set-tag]').textContent = b.dataset.name;
        $$('.me-piece', sec).forEach(function (r) { r.hidden = r.dataset.color !== colour; });
        // Carry chosen sizes and ticks over to the new colour
        rows().forEach(function (r) {
          var old = prev.filter(function (p) { return p.dataset.slot === r.dataset.slot; })[0];
          if (!old) return;
          r.querySelector('input').checked = old.querySelector('input').checked;
          var o = old.querySelector('select').selectedOptions[0];
          var size = o && o.dataset.size;
          var s = r.querySelector('select');
          var match = size && $$('option', s).filter(function (x) { return x.dataset.size === size && !x.disabled; })[0];
          s.value = match ? match.value : '';
        });
        total();
      });
    });
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-disabled') === 'true') return;
      var picked = rows().filter(function (r) { return r.querySelector('input').checked; });
      var missing = picked.filter(function (r) { return !r.querySelector('select').value; });
      missing.forEach(function (r) { r.querySelector('select').classList.add('is-missing'); });
      if (missing.length) { say('Veldu stærð fyrir hverja flík sem þú tekur.', 'size'); missing[0].querySelector('select').focus(); return; }
      btn.setAttribute('aria-disabled', 'true');
      addToCart(picked.map(function (r) { return { id: +r.querySelector('select').value, quantity: 1 }; }))
        .then(function () {
          say(picked.length + (picked.length === 1 ? ' flík komin í körfuna.' : ' flíkur komnar í körfuna.'));
          btn.textContent = 'Bætt í körfu';
          setTimeout(function () { btn.textContent = label; }, 2400);
        })
        .catch(function (e) { say(e.message, 'error'); })
        .then(function () { btn.setAttribute('aria-disabled', 'false'); });
    });
    total();
  });

  // Collection filters and sort
  $$('[data-me-filter]').forEach(function (sec) {
    var grid = sec.querySelector('[data-me-grid]');
    if (!grid) return;
    var cards = $$('.me-card', grid);
    var promo = grid.querySelector('[data-me-promo]');
    var empty = grid.querySelector('[data-me-empty]');
    var count = sec.querySelector('[data-me-count]');
    var state = { piece: 'all', color: null };
    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (state.piece === 'all' || c.dataset.piece === state.piece) &&
          (!state.color || (' ' + c.dataset.colors + ' ').indexOf(' ' + state.color + ' ') > -1);
        c.hidden = !ok; if (ok) shown++;
      });
      if (promo) promo.hidden = state.piece !== 'all' || !!state.color;
      if (empty) empty.hidden = shown > 0;
      if (count) count.textContent = shown === 1 ? '1 vara' : shown + ' vörur';
      $$('.me-fchip', sec).forEach(function (b) {
        var on = b.dataset.f === 'piece' ? b.dataset.v === state.piece : b.dataset.v === state.color;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    $$('.me-fchip', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.f === 'piece') { state.piece = b.dataset.v; if (b.dataset.v === 'all') state.color = null; }
        else state.color = state.color === b.dataset.v ? null : b.dataset.v;
        apply();
      });
    });
    var reset = grid.querySelector('[data-me-reset]');
    if (reset) reset.addEventListener('click', function () { state = { piece: 'all', color: null }; apply(); });
    var sort = sec.querySelector('[data-me-sort]');
    if (sort) sort.addEventListener('change', function () {
      var v = sort.value;
      cards.slice().sort(function (a, b) {
        if (v === 'asc') return a.dataset.price - b.dataset.price || a.dataset.order - b.dataset.order;
        if (v === 'desc') return b.dataset.price - a.dataset.price || a.dataset.order - b.dataset.order;
        return a.dataset.order - b.dataset.order;
      }).forEach(function (c, i) {
        grid.insertBefore(c, empty);
        if (promo && i === 2) grid.insertBefore(promo, empty);
      });
    });
  });

  // Dialogs (size chart)
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-me-dialog-open]');
    if (open) {
      var d = document.getElementById(open.dataset.meDialogOpen);
      if (d && d.showModal) { d.showModal(); markSize(); }
      return;
    }
    if (e.target.closest('[data-me-dialog-close]')) { e.target.closest('dialog').close(); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('me-dialog')) e.target.close();
  });

  // Product page: selected variant drives the stock note, the size chart highlight and the complete-the-set sizes
  var pdp = document.querySelector('[data-me-pdp]');
  var variants = [];
  if (pdp) {
    try { variants = JSON.parse(pdp.querySelector('[data-me-variants]').textContent); } catch (err) { variants = []; }
  }
  function currentVariant() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var id = input ? +input.value : 0;
    var p = new URLSearchParams(location.search).get('variant');
    return variants.filter(function (v) { return v.id === id; })[0] ||
      variants.filter(function (v) { return String(v.id) === p; })[0] || null;
  }
  function markSize() {
    var v = currentVariant();
    $$('.me-dialog tr[data-size]').forEach(function (tr) { tr.classList.toggle('is-mine', !!v && tr.dataset.size === v.size); });
  }
  function syncPdp() {
    if (!pdp) return;
    var v = currentVariant();
    var note = pdp.querySelector('[data-me-stock]');
    var soldOut = variants.filter(function (x) { return !x.available; }).map(function (x) { return x.size; });
    var text = '', low = false;
    if (v && !v.available) { text = v.size + ' er uppselt.'; }
    else if (v && v.low) { text = v.low === 1 ? 'Aðeins 1 eftir.' : 'Aðeins ' + v.low + ' eftir.'; low = true; }
    else if (soldOut.length && soldOut.length < variants.length) { text = soldOut.join(', ') + ' uppselt.'; }
    note.textContent = text;
    note.classList.toggle('is-low', low);
    markSize();
    if (!v) return;
    $$('[data-me-complete] select[data-me-citem-select]').forEach(function (s) {
      if (s.dataset.touched) return;
      var opts = $$('option', s).filter(function (o) { return o.value && !o.disabled; });
      var m = opts.filter(function (o) { return o.dataset.title === v.title; })[0] ||
        opts.filter(function (o) { return o.dataset.size === v.size; })[0];
      if (m) { s.value = m.value; citemImage(s); }
    });
  }
  if (pdp) {
    ['change', 'click'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target.closest && e.target.closest('form[action*="/cart/add"], [data-product-option], .product__chip')) setTimeout(syncPdp, 60);
      });
    });
    syncPdp();
  }

  // Complete the set: the thumbnail follows the chosen colour when the variant has its own photo
  function citemImage(sel) {
    var o = sel.selectedOptions && sel.selectedOptions[0];
    var img = sel.closest('.me-citem').querySelector('.me-citem__img img');
    if (o && o.dataset.img && img) { img.removeAttribute('srcset'); img.src = o.dataset.img; }
  }
  $$('[data-me-complete]').forEach(function (sec) {
    $$('.me-citem', sec).forEach(function (item) {
      var sel = item.querySelector('[data-me-citem-select]');
      var note = item.querySelector('[data-me-citem-note]');
      var btn = item.querySelector('[data-me-citem-add]');
      if (sel.tagName === 'SELECT') sel.addEventListener('change', function () { sel.dataset.touched = '1'; sel.classList.remove('is-missing'); note.textContent = ''; citemImage(sel); });
      btn.addEventListener('click', function () {
        if (!sel.value) { sel.classList.add('is-missing'); note.textContent = 'Veldu stærð fyrst.'; sel.focus(); return; }
        btn.disabled = true;
        addToCart([{ id: +sel.value, quantity: 1 }])
          .then(function () { note.textContent = 'Komið í körfuna.'; })
          .catch(function (e) { note.textContent = e.message; })
          .then(function () { btn.disabled = false; });
      });
    });
  });

  // Collection intro: read more on phone
  $$('[data-me-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var t = b.previousElementSibling;
      var open = t.classList.toggle('is-open');
      b.textContent = open ? 'Sýna minna' : 'Lesa meira';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // Newsletter: Icelandic validation message before the form posts
  $$('[data-me-news]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('input[type="email"]');
      var msg = document.getElementById('me-news-msg');
      if (!input) return;
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim())) {
        e.preventDefault();
        form.classList.add('is-error');
        if (msg) msg.textContent = 'Sláðu inn gilt netfang, til dæmis nafn@dæmi.is.';
        input.focus();
      }
    });
  });

  // Product recommendations load after the page
  $$('[data-me-reco]').forEach(function (sec) {
    if (sec.children.length) return;
    fetch(sec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-me-reco]');
      if (fresh && fresh.children.length) sec.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();